function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
import { throttle } from "throttle-debounce";
/**
 * The message stream can send hundreds of messages per second but dispatching
 * an update causes a re-render which can take 20-50ms. So batch messages as
 * they arrive and send them in groups every 200ms.
 */ export var StdStreamDispatcher = /*#__PURE__*/ function() {
    "use strict";
    function StdStreamDispatcher(kernelSessionId, updateStdStream) {
        var _this = this;
        _classCallCheck(this, StdStreamDispatcher);
        this.kernelSessionId = kernelSessionId;
        this.batches = {};
        this.dispatchBatchedData = function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.keys(_this.batches)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var streamType = _step.value;
                    if (_this.batches[streamType].length > 0) {
                        _this.updateStdStream(_this.kernelSessionId, streamType, _this.batches[streamType]);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            _this.batches = {};
        };
        this.throttledDispatchBatchedData = throttle(200, this.dispatchBatchedData);
        this.updateStdStream = updateStdStream;
    }
    _createClass(StdStreamDispatcher, [
        {
            key: "addLine",
            value: function addLine(streamType, line) {
                this.batches[streamType] = this.batches[streamType] || [];
                this.batches[streamType].push(line);
                this.throttledDispatchBatchedData();
            }
        }
    ]);
    return StdStreamDispatcher;
}();
